export function ShieldSecurityLinear({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 28.45C13.6375 28.45 12.2875 28.05 11.225 27.2625L5.85 23.25C4.425 22.1875 3.3125 19.975 3.3125 18.2001V8.90005C3.3125 6.97505 4.725 4.92505 6.5375 4.25005L12.775 1.91255C14.0125 1.45005 15.9625 1.45005 17.2 1.91255L23.45 4.25005C25.2625 4.92505 26.675 6.97505 26.675 8.90005V18.1875C26.675 19.9625 25.5625 22.175 24.1375 23.2375L18.7625 27.25C17.7125 28.05 16.3625 28.45 15 28.45ZM13.4375 3.67505L7.2 6.01255C6.125 6.41255 5.1875 7.76255 5.1875 8.91255V18.2001C5.1875 19.3876 6.025 21.05 6.9625 21.75L12.3375 25.7625C13.775 26.8375 16.2125 26.8375 17.65 25.7625L23.025 21.75C23.975 21.0375 24.8 19.375 24.8 18.2001V8.90005C24.8 7.76255 23.8625 6.41255 22.7875 6.00005L16.55 3.66255C15.725 3.36255 14.275 3.36255 13.4375 3.67505Z"
          fill="currentColor"
        />
        <path
          d="M15 16.5625C13.1 16.5625 11.5625 15.025 11.5625 13.125C11.5625 11.225 13.1 9.6875 15 9.6875C16.9 9.6875 18.4375 11.225 18.4375 13.125C18.4375 15.025 16.9 16.5625 15 16.5625ZM15 11.5625C14.1375 11.5625 13.4375 12.2625 13.4375 13.125C13.4375 13.9875 14.1375 14.6875 15 14.6875C15.8625 14.6875 16.5625 13.9875 16.5625 13.125C16.5625 12.2625 15.8625 11.5625 15 11.5625Z"
          fill="currentColor"
        />
        <path
          d="M15 20.3125C14.4875 20.3125 14.0625 19.8875 14.0625 19.375V15.625C14.0625 15.1125 14.4875 14.6875 15 14.6875C15.5125 14.6875 15.9375 15.1125 15.9375 15.625V19.375C15.9375 19.8875 15.5125 20.3125 15 20.3125Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
